module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex",
    class: _vm.canOperate ? 'pb-fixed-flex-bot' : ''
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "bg-fff pd-025"
  }, [_c('div', {
    staticClass: "flex pd-250 fs-32 bd-bot"
  }, [_c('div', {
    staticClass: "flex1 color-333"
  }, [_vm._v(_vm._s(_vm.entity.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "color-org"
  }, [_vm._v("货道 " + _vm._s(_vm.entity.wayCode))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-between fs-28 color-333 pd-250"
  }, [_c('div', [_vm._v("补货人：" + _vm._s(_vm.entity.linkName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.entity.operateTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pd-025 pb-25 scroll-view"
  }, _vm._l((_vm.entity.userOrderInfoVOList), function(userOrder, userOrder$index) {
    return _c('div', _vm._l((userOrder.orderInfoVo), function(order, $orderIndex) {
      return (_vm.entity.userOrderInfoVO) ? _c('div', {
        key: $orderIndex,
        staticClass: "card mt-20 pd-25"
      }, [_c('div', {
        staticClass: "fs-28 font-bold color-333 mb-10"
      }, [_vm._v("收货人：" + _vm._s(order.userName) + "  "), _c('span', {
        staticClass: "ml-10"
      }, [_vm._v(_vm._s(order.userMobile))])]), _vm._v(" "), _c('div', {
        staticClass: "fs-24 color-999"
      }, [_vm._v("订单号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('div', {
        staticClass: "list"
      }, _vm._l((order.productList), function(prod, $prodIndex) {
        return _c('div', {
          key: $prodIndex,
          staticClass: "flex mt-30"
        }, [_c('div', {
          staticClass: "item-img mr-20"
        }, [_c('img', {
          attrs: {
            "src": prod.imgPathView,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "flex1"
        }, [_c('div', {
          staticClass: "fs-28 color-000"
        }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), _c('div', {
          staticClass: "fs-24 color-999 mt-15"
        }, [_vm._v("x" + _vm._s(prod.productQty))])])])
      }), 0)]) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), (_vm.canOperate) ? _c('div', {
    staticClass: "fixed-flex-bot"
  }, [_c('div', {
    staticClass: "flex-btn click",
    on: {
      "click": _vm.openDoor
    }
  }, [_vm._v("取货")]), _vm._v(" "), _c('div', {
    staticClass: "flex-btn active ml-10 click",
    on: {
      "click": _vm.replenishOrder
    }
  }, [_vm._v("补货")])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '80vh'
    }),
    attrs: {
      "position": "bottom",
      "lazy-render": false
    },
    model: {
      value: (_vm.popupShow),
      callback: function($$v) {
        _vm.popupShow = $$v
      },
      expression: "popupShow"
    }
  }, [_c('div', {
    staticClass: "popup-container"
  }, [_c('div', {
    staticClass: "title fs-34 text-center pd-200"
  }, [_vm._v("请选择要解绑的订单")]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pd-025 pb-25 scroll-view bg-gray"
  }, _vm._l((_vm.entity.userOrderInfoVOList), function(userOrder, userOrder$index) {
    return _c('div', _vm._l((userOrder.orderInfoVo), function(order, $orderIndex) {
      return (_vm.entity.userOrderInfoVO) ? _c('div', {
        key: $orderIndex,
        staticClass: "card mt-20 pd-25 posi-rel",
        on: {
          "click": function($event) {
            return _vm.chooseOrder(userOrder$index, $orderIndex)
          }
        }
      }, [_c('div', {
        staticClass: "fs-28 font-bold color-333 mb-10"
      }, [_vm._v("收货人：" + _vm._s(order.userName) + "  "), _c('span', {
        staticClass: "ml-10"
      }, [_vm._v(_vm._s(order.userMobile))])]), _vm._v(" "), _c('div', {
        staticClass: "fs-24 color-999"
      }, [_vm._v("订单号：" + _vm._s(order.orderNo))]), _vm._v(" "), _c('div', {
        staticClass: "list"
      }, _vm._l((order.productList), function(prod, $prodIndex) {
        return _c('div', {
          key: $prodIndex,
          staticClass: "flex mt-30"
        }, [_c('div', {
          staticClass: "item-img mr-20"
        }, [_c('img', {
          attrs: {
            "src": prod.imgPathView,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "flex1"
        }, [_c('div', {
          staticClass: "fs-28 color-000"
        }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), _c('div', {
          staticClass: "fs-24 color-999 mt-15"
        }, [_vm._v("x" + _vm._s(prod.productQty))])])])
      }), 0), _vm._v(" "), _c('div', {
        staticClass: "choose-icon alifont",
        class: order.isChoose ? 'color-main icon-xuanzhong' : 'icon-weixuanzhong color-999'
      })]) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cancel-btn click",
    on: {
      "click": _vm.cancelBindOrder
    }
  }, [_vm._v("取消绑定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f13b0a9","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/lockerOrderDetail.vue
// module id = AoU5
// module chunks = 51